import { Dictionary } from '@/i18n/i18n.setup';
import { SortByItemKeys } from '@/types/common/sort-by-item-keys';

export const uiConfig = {
  getSortByItems: (t: Dictionary | undefined) => ({
    [SortByItemKeys.NONE]: t?.products.sort,
    [SortByItemKeys.PRICE_LOW_TO_HIGH]: t?.products.priceLowToHigh,
    [SortByItemKeys.PRICE_HIGH_TO_LOW]: t?.products.priceHighToLow,
  }),

  useOldAppBar: false,
  useOldFooter: false,
};
